export default __webpack_public_path__ + "static/Depop_newsroom-3969df27528c908c2c2ce38493456b06.jpg";